let globalNavigate = null

export const setNavigate = (navigate) => {
  globalNavigate = navigate
}

export const appNavigate = (path, options) => {
  if (globalNavigate) {
    globalNavigate(path, options)
  } else {
    window.location.pathname = path
  }
}
